import { render, staticRenderFns } from "./NotificationTooltipHeader.vue?vue&type=template&id=2c920ea8&scoped=true&"
import script from "./NotificationTooltipHeader.vue?vue&type=script&lang=js&"
export * from "./NotificationTooltipHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c920ea8",
  null
  
)

export default component.exports